<template>
<div>
    <hr />
    <h4 class="page-header page-header-blue">Job Steps <button type="button" class="btn btn-sm btn-info" v-on:click="addJsaStep()" title="Add Job Step"><i class="fa fa-plus"></i> Step</button></h4>
    <div class="row">
        <div class="col-sm-10" v-if="steps">
            <div v-for="(step, ix) in steps">
                <div v-bind:class="{ 'form-group': true, 'has-error': errors['step'] }">
                    <div style="position: relative;">
                        <div :id="`step-${ix}`" class="panel panel-default jsa-step">
                            <div class="panel-heading form-inline">
                                <div class="form-group input-group-sm">
                                    <label>Step:</label>
                                    <input type="text" :name="`job_steps[${ix}][step_label]`" class="form-control" placeholder="Enter Step Description" style="width: 300px;" v-model="steps[ix].step_label" />
                                </div>
                                <button type="button" class="btn btn-xs btn-danger pull-right" title="Delete Step" v-on:click="removeJsaStep(`${ix}`)"><i class="fa fa-remove"></i></button>
                            </div>
                            <div class="panel-body"></div>
                        </div>
                        <jsa-job-step-hazard :stepId="`${ix}`"></jsa-job-step-hazard>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export default {

    data: function() {
        return {
            loading: true,
            jsa: {},
            errors: {},
            steps: {},
        }
    },

    methods: {

        addJsaStep: function(step) {
            //Variables
            var tempId = (new Date()).getTime();
            var description = '';

            //If a step was passed in, update the id
            if (step !== undefined) {
                description = step.step_label;
            } else { //Append step to store
                if (!this.jsa.UserId) {
                    this.jsa = this.$store.state.JsaStoreModule.jsa;
                }
                // if job_steps is an array, delete it
                if (typeof this.jsa.jsa_steps != 'object' || Array.isArray(this.jsa.jsa_steps)) {
                    this.$delete(this.jsa, 'jsa_steps');
                }
                // add the job_steps array if needed
                if (!("jsa_steps" in this.jsa)) {
                    this.jsa.jsa_steps = {};
                }
                // You have to use the set function to make the data react with the template
                this.steps = this.jsa.jsa_steps;
                var tmp_obj = {
                    'step_label': '',
                    'hazards': {}
                };
                this.$set(this.steps, tempId, tmp_obj);
                this.jsa.jsa_steps = this.steps;
                this.$store.commit('putJsa', this.jsa);

            }
        },

        removeJsaStep: function(step) {
            //				this.jsa = this.$store.state.JsaStoreModule.jsa;
            this.$delete(this.steps, step);
            this.jsa.jsa_steps = this.steps;
            this.$store.commit('putJsa', this.jsa);
        }

    },

    mounted() {
        sleep(500).then(() => {
            this.jsa = this.$store.state.JsaStoreModule.jsa;

            // case editing existing
            if (this.jsa.jsa_steps) {
                this.steps = this.jsa.jsa_steps;
            }
            this.loading = false;
        });
    }
}
</script>
